import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { Navigate, Outlet } from 'react-router'
import { Card, CardContent } from '@/components/ui/card'
import { buildPath } from '@/routes'
import { HasFeature } from '@/components/Atoms/Permissions'
import { CredentialingFeature } from '@/lib/features'

export function CredentialingLayout() {
  return (
    <HasFeature
      feature={CredentialingFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb label="Credentialing" path={buildPath('/credentialing')} />
      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </HasFeature>
  )
}
